import React, { Component } from 'react'
import { connect } from 'react-redux'

import classNames from './Image.css'
import { fetchImage, flagImage } from '../redux/image'
import { fetchAlbums } from '../redux/albums'
import { setFavouriteImage } from '../redux/album'
import { fetchSearchOptions } from '../redux/search'
import { createImageGetter, getDate, getFavouriteImages } from '../utils/images'
import { userHasPerm, isAnonymous } from '../utils/auth'
import GroupedKeywords from '../components/GroupedKeywords'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import Gallery from '../components/gallery/Gallery'
import Icon from '../components/Icon'

class Image extends Component {
  state = {
    showAll: false,
    showFlagModal: false
  }
  componentDidMount () {
    const { favouriteImages, fetchAlbums } = this.props
    this.fetch()

    if (!favouriteImages) {
      fetchAlbums()
    }
    if (!this.props.keywordMap) {
      this.props.fetchSearchOptions()
    }
  }
  componentWillReceiveProps (nextProps) {
    const { params } = this.props
    if (params.id !== nextProps.params.id) {
      this.fetch(nextProps)
    }
  }
  fetch ({ params, image, fetchImage } = this.props) {
    if (!image.Filename) {
      fetchImage(params.id)
    }
  }
  toggleInfo = () => {
    this.setState({
      showAll: !this.state.showAll
    })
  }
  getAlbumPaths = paths => {
    const { userLibraries } = this.props
    if (!paths || paths.length === 0) {
      return null
    }
    return paths.filter(path => {
      // Filter out paths in libraries the user cannot access
      const split = path.split('/')
      if (split.length >= 3 && userLibraries.indexOf(split[2]) === -1) {
        return false
      }
      // Filter out paths that are a substring of the full path
      for (let p of paths) {
        if (p.indexOf(path + '/') !== -1) {
          return false
        }
      }
      return true
    })
  }
  renderButtons () {
    const { image, favouriteImages, setFavouriteImage, canFlag } = this.props
    const favourited = favouriteImages && favouriteImages.indexOf(image._id) !== -1
    return (
      <div className={classNames.icons}>
        {canFlag &&
          <button
            className={classNames.iconButton}
            onClick={() => this.setState({ showFlagModal: true })}>
            <Icon icon='flag' className={image.flagged ? null : classNames.outline} />
          </button>
        }
        {favouriteImages &&
          <button
            className={classNames.iconButton}
            onClick={() => setFavouriteImage(image._id, !favourited)}>
            <Icon icon={favourited ? 'heart' : 'heart-outline'} />
          </button>
        }
      </div>
    )
  }
  renderInfo (key, value) {
    if (key === 'AlbumPaths') {
      value = this.getAlbumPaths(value)
    }
    return [
      <dt key='dt'>{key}</dt>,
      <dd key='dd'>{this.renderValue(key, value)}</dd>
    ]
  }
  renderValue (key, value) {
    const { keywordMap } = this.props
    if (!value) {
      return 'Unknown'
    }
    if (value instanceof Array) {
      return (
        <ul className={classNames.infoList}>
          {value.map(item => {
            if (keywordMap && (key === '_keywords' || key === 'ExpandedKeywords')) {
              return <li key={item}>{keywordMap[item] ? keywordMap[item].name : item}</li>
            }
            return <li key={item}>{item}</li>
          })}
        </ul>
      )
    }
    return value
  }
  renderAllInfo (image) {
    return Object.keys(image).map(key => {
      if (key === 'Albums') {
        return null
      }
      if (typeof image[key] === 'string' || typeof image[key] === 'number' || image[key] instanceof Array) {
        return this.renderInfo(key, image[key])
      }
      return null
    })
  }
  render () {
    const { image, getImageSource, userLibraries, canViewAdvanced, onClickThumbnail } = this.props
    const { showAll } = this.state

    let keywords = image._keywords
    if (typeof keywords === 'string') {
      keywords = [ keywords ]
    }

    const libraries = (image.LibraryName || [])
      .filter(lib => userLibraries.indexOf(lib) !== -1)
      .join(', ')

    return (
      <div className={classNames.page}>
        {!onClickThumbnail && image._id &&
          <Gallery
            style={{ padding: '0 0 20px 0' }}
            images={[ image ]}
            getImageSource={getImageSource}
            showInfoLink={false}
            entities={this.props.entities}
            canShareImagesInternal={this.props.canShareInternal}
            canShareImagesExternal={this.props.canShareExternal}
          />
        }
        {onClickThumbnail && image._id &&
          <Thumb
            onClick={onClickThumbnail}
            className={classNames.thumb}
            style={{ backgroundImage: `url(${getImageSource(image._id)})` }}
          />
        }
        {image.fetching &&
          <LoadingSpinner />
        }
        {image.error &&
          <ErrorMessage
            message='There was an error fetching image information'
            onRetry={() => this.fetch()}
          />
        }
        {image.Filename &&
          <ul className={classNames.info}>
            <li><b>Filename</b> {image.Filename}</li>
            <li><b>Blayzr ID</b> {image._id}</li>
            <li><b>Image date</b> {getDate(image._date) || 'Unknown'}</li>
            <li><b>Event path</b> {image._event || 'No event path'}</li>
            <li><b>Library</b> {libraries.length !== 0 ? libraries : 'Shared with you'}</li>
          </ul>
        }
        {image.Filename &&
          <GroupedKeywords imageID={image._id} />
        }
        {canViewAdvanced && image.Filename &&
          <button className={classNames.button} onClick={this.toggleInfo}>
            {showAll ? 'Hide advanced fields' : 'Show advanced fields'}
          </button>
        }
        {showAll && this.renderAllInfo(image)}
        {showAll &&
          <button className={classNames.button} onClick={this.toggleInfo}>
            Hide advanced fields
          </button>
        }
      </div>
    )
  }
}

class Thumb extends Component {
  shouldComponentUpdate () {
    return false
  }
  render () {
    return <div {...this.props} />
  }
}

const mapStateToProps = (state, { params }) => {
  return {
    entities: state.entities,
    image: state.entities.images[params.id] || {},
    getImageSource: createImageGetter(state.auth),
    favouriteImages: getFavouriteImages(state),
    canShareInternal: userHasPerm(state.auth.user, 'internal_share'),
    canShareExternal: userHasPerm(state.auth.user, 'external_share'),
    canFlag: userHasPerm(state.auth.user, 'flag_image'),
    canViewAdvanced: userHasPerm(state.auth.user, 'advanced_info'),
    anonymousUser: isAnonymous(state.auth.user),
    userLibraries: state.auth.user.libraries.map(l => l.library.library_token),
    keywordMap: state.search.options.keywordMap
  }
}

const mapDispatchToProps = {
  fetchImage,
  flagImage,
  fetchAlbums,
  setFavouriteImage,
  fetchSearchOptions
}

export default connect(mapStateToProps, mapDispatchToProps)(Image)



// WEBPACK FOOTER //
// ./src/pages/Image.js